/**
 * List of features enable globally, each component can be wrapp in feature component, which togggle its base on this config
 */
export default [];
